<template>
    <div class="module-related-list">
        <div class="module-related-list__container">
            <div class="module-related-list__menu" v-if="modules.length > 0">
                <div
                    v-for="module in modules"
                    :key="module.id"
                    @click="selectedModule = module"
                    class="module-related-list__menu-item"
                    :class="{ selected: $_.get(selectedModule, 'moduleName') === module.moduleName }"
                >
                    <i class="material-icons">{{ module.icon || "list" }}</i>
                    <span>{{ module.displayName }}</span>
                </div>
            </div>

            <div
                class="module-related-list__content"
                v-if="modules.length > 0"
                :key="$_.get(selectedModule, 'moduleName')"
            >
                <div class="module-related-list__content-inner" v-if="selectedModule">
                    <TableDetail
                        :defaultRecords="records"
                        :moduleMode="true"
                        :defaultTableId="selectedModule.relation.module"
                        :predefinedValues="getTablePredefinedValues()"
                        @record-created="onRecordCreated"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { MODULE_API } from "../../../../api/module";
import TableDetail from "./TableDetail.vue";
export default {
    name: "ModuleRelatedList",
    components: {
        TableDetail,
    },
    data() {
        return {
            selectedModule: null,
            records: [],
            loading: false,
            modules: [],
        };
    },
    props: {
        tableId: {
            type: String,
            required: true,
        },
        recordId: {
            type: String,
            required: true,
        },
    },
    computed: {
        ...mapGetters("module", ["getTableRelatedModules"]),
    },
    methods: {
        redirectToTables() {
            this.$router.push("/tables");
        },
        fetchRelatedModuleRecords() {
            if (!this.selectedModule) return;
            return MODULE_API.getModuleRelatedList(this.selectedModule.moduleName, this.tableId, this.recordId)
                .then((result) => {
                    this.records = result.items;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getTablePredefinedValues() {
            const module = this.selectedModule;
            const remoteField = module.relation?.remoteField;
            let filterValue;
            
            return {
                [remoteField]: filterValue,
            };
        },
        onRecordCreated(newRecord) {
            this.fetchRelatedModuleRecords();
        },
    },
    created() {
        this.modules = this.getTableRelatedModules(this.tableId);
        this.selectedModule = this.modules[0];
    },
    watch: {
        selectedModule: {
            handler(newVal) {
                this.records = [];
                this.fetchRelatedModuleRecords();
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss">
.module-related-list {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    &__container {
        display: flex;
        height: 100%;
    }

    &__menu {
        flex: 0 0 200px;
        border-right: 1px solid #e8e8e8;
        height: 100%;
        &-item {
            display: flex;
            align-items: center;
            gap: 8px;
            cursor: pointer;
            padding: 8px;
            border-radius: 4px;
            font-size: 14px;
            color: #333;
            &:hover {
                background-color: #f0f0f0;
            }
            &.selected {
                background-color: #e8e8e8;
            }
        }
    }

    &__create-button {
        margin-bottom: 16px;
    }

    &__content {
        flex: 1;
        height: 100%;
        width: 100%;
        overflow: hidden;
        &-inner {
        }

        .table-body {
            width: 100%;
            overflow: scroll;
        }
    }
}
</style>
